/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Pizza = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Pizza"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#FFC220"
        d="M20.623 2c.49 0 .877.405.877.895v17.349c0 1.35-1.462 2.194-2.632 1.518l-14.83-8.556c-.846-.488-1.136-1.579-.568-2.374C7.29 5.486 13.548 2 20.623 2"
        className="Fill-Main"
      />
      <g className="Fill-Secondary">
        <path
          fill="#FFC220"
          d="M21.5 2.896A.886.886 0 0 0 20.622 2C13.638 2 7.448 5.398 3.616 10.63c-.658.899-.327 2.144.638 2.701l1.286.742c3.063-5.13 8.671-8.565 15.083-8.565q.44 0 .877.021z"
        />
        <path
          fill="#000"
          fillOpacity={0.2}
          d="M21.5 2.896A.886.886 0 0 0 20.622 2C13.638 2 7.448 5.398 3.616 10.63c-.658.899-.327 2.144.638 2.701l1.286.742c3.063-5.13 8.671-8.565 15.083-8.565q.44 0 .877.021z"
        />
      </g>
      <path
        fill="#F50"
        d="M15.357 19.682a2.195 2.195 0 0 1 3.8 2.193zm3.95-6.282a2.193 2.193 0 1 1-2.195 2.192c0-1.211.983-2.192 2.194-2.192m-7.021-1.754a2.193 2.193 0 1 1 .002 4.386 2.193 2.193 0 0 1-.002-4.386m4.388-4.385a2.194 2.194 0 1 1-2.193 2.192c0-1.21.981-2.191 2.193-2.192"
        className="Fill-Accent"
      />
    </g>
  </svg>
);

export const PizzaIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'pizza-icon'}
      icon={Pizza}
      {...props}
      size={size}
    />
  );
};
